import {
  createImageUrlAutoFormField,
  type SpecsAutoFormFieldMetadataMap,
} from "../autoFormMetadata";
import { ObservableModelNode } from "../observable";
import { cloneValue, expectObject, readString, splitKnown } from "../utils";

export class ProductVersionPackagingModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    hangTagInstructionsUrl: createImageUrlAutoFormField({
      label: "Hang Tag Instructions URL",
    }),
    polybagUrl: createImageUrlAutoFormField({ label: "Polybag URL" }),
    polybagWithHangTagUrl: createImageUrlAutoFormField({
      label: "Polybag With Hang Tag URL",
    }),
    polybagWithSkuUrl: createImageUrlAutoFormField({
      label: "Polybag With SKU URL",
    }),
    skuSticker: createImageUrlAutoFormField({ label: "SKU Sticker URL" }),
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  hangTagInstructionsUrl!: string;
  polybagUrl!: string;
  polybagWithHangTagUrl!: string;
  polybagWithSkuUrl!: string;
  skuSticker!: string;
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("hangTagInstructionsUrl", "");
    this.defineObservableValue("polybagUrl", "");
    this.defineObservableValue("polybagWithHangTagUrl", "");
    this.defineObservableValue("polybagWithSkuUrl", "");
    this.defineObservableValue("skuSticker", "");
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "product packaging metadata");
    this.hangTagInstructionsUrl = readString(source, "hangTagInstructionsUrl");
    this.polybagUrl = readString(source, "polybagUrl");
    this.polybagWithHangTagUrl = readString(source, "polybagWithHangTagUrl");
    this.polybagWithSkuUrl = readString(source, "polybagWithSkuUrl");
    this.skuSticker = readString(source, "skuSticker");
    this.extra = splitKnown(source, [
      "hangTagInstructionsUrl",
      "polybagUrl",
      "polybagWithHangTagUrl",
      "polybagWithSkuUrl",
      "skuSticker",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.hangTagInstructionsUrl
        ? { hangTagInstructionsUrl: this.hangTagInstructionsUrl }
        : {}),
      ...(this.polybagUrl ? { polybagUrl: this.polybagUrl } : {}),
      ...(this.polybagWithHangTagUrl
        ? { polybagWithHangTagUrl: this.polybagWithHangTagUrl }
        : {}),
      ...(this.polybagWithSkuUrl
        ? { polybagWithSkuUrl: this.polybagWithSkuUrl }
        : {}),
      ...(this.skuSticker ? { skuSticker: this.skuSticker } : {}),
    };
  }
}
